// const serviceStartTime = "2021-08-20 00:00:00";
const serviceStartTime = getServiceStartTime();
const defaultStartTime = getTimestamp();

function getTimestamp() {
  // @ts-ignore
  const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
  const d = new Date(new Date().setMonth(new Date().getMonth() - 1));

  return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth(), 1)}-${pad(
    d.getDate()
  )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function getServiceStartTime() {
  // @ts-ignore
  const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
  const d = new Date(new Date().setFullYear(new Date().getFullYear() - 5));

  return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate()
  )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export { serviceStartTime, defaultStartTime };
